export default __webpack_public_path__ + "static/media/markings.9d6ba384.png";